import React, { useEffect, useState } from 'react'
import { StepProvider, useStepContext } from './Context/StepContext'
import { WorkingStatus } from './Steps/StepContent/WorkingStatus'
import { ExperienceYears } from './Steps/StepContent/ExperienceYears'
import { Prefecture } from './Steps/StepContent/Prefecture'
import { FullName } from './Steps/StepContent/FullName'
import { Tell } from './Steps/StepContent/Tell'
import styles from './EntryFormSlideApp.module.css'
import { generateUrlSafeBase64 } from './utils/securityUtils'
import { handleFormSubmission } from './utils/formSubmissionUtils'
import { SERVICE_TYPES } from '@/components/constants'

const SlideContent = ({ prefectures }) => {
    const { currentStep, isAnimating, formData } = useStepContext()
    const [formBoxHeight, setFormBoxHeight] = useState('auto')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [registerToken, setRegisterToken] = useState('')

    useEffect(() => {
        const token = generateUrlSafeBase64()
        setRegisterToken(token)
    }, [])

    useEffect(() => {
        if (currentStep === 4) {
            setFormBoxHeight('auto')
        } else {
            setFormBoxHeight('400px')
        }
    }, [currentStep])

    useEffect(() => {
        const handleGlobalTab = (e) => {
            if (e.key === 'Tab') {
                e.preventDefault()
            }
        }
        document.addEventListener('keydown', handleGlobalTab)
        return () => {
            document.removeEventListener('keydown', handleGlobalTab)
        }
    }, [])

    const sliderStyle = {
        transform: `translateX(-${currentStep * 100}%)`
    }

    const handleSubmit = (e) => {
        handleFormSubmission(e, formData, registerToken, setIsSubmitting, SERVICE_TYPES.FOODSLABO)
    }

    return (
        <div className={styles.entryFormSlideApp}>
            <section className={styles.container}>
                <div
                    className={styles.formBox}
                    style={{height: formBoxHeight, transition: 'height 0.5s ease-in-out'}}
                >
                    <header className={styles.header}>
                        <h2 className={styles.title}>簡単15秒！</h2>
                        <h1 className={styles.subtitle}>無料エントリー</h1>
                    </header>
                    <form
                        onSubmit={handleSubmit}
                    >
                        <div className={styles.formContainer}>
                            <div className={styles.formWrapper} style={sliderStyle}>
                                <div className={styles.stepContent}>
                                    <WorkingStatus/>
                                </div>
                                <div className={styles.stepContent}>
                                    <ExperienceYears/>
                                </div>
                                <div className={styles.stepContent}>
                                    <Prefecture prefectures={prefectures} />
                                </div>
                                <div className={styles.stepContent}>
                                    <FullName/>
                                </div>
                                <div
                                    className={`${styles.stepContent} ${currentStep === 4 ? styles.tellStep : ''}`}>
                                    <Tell isSubmitting={isSubmitting}/>
                                </div>
                            </div>
                        </div>
                        {isAnimating && <div className={styles.blockingOverlay}/>}
                    </form>
                </div>
            </section>
        </div>
    )
}

const EntryFormSlideApp = ({ prefectures }) => {
    return (
        <StepProvider>
            <SlideContent prefectures={prefectures} />
        </StepProvider>
    )
}

export default EntryFormSlideApp
